import React from 'react';

function NextPlay () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.286.714v18.572"
      />
      <path
        fill="#fff"
        d="M.714 16.656a1.428 1.428 0 00.743 1.257 1.428 1.428 0 001.429 0L13.157 11.2a1.43 1.43 0 000-2.4l-10.3-6.657a1.429 1.429 0 00-1.428 0 1.429 1.429 0 00-.743 1.257l.028 13.257z"
      />
    </svg>
  );
}

export default NextPlay;
